import { useMemo } from "react";
import { useAuth } from "@/contexts/AuthContext";
import { Navigate, useLocation } from "react-router-dom";

/**
 * Enforce a specific role. Renders children only if the current user has one
 * of the allowed roles. Otherwise redirects to the role's home dashboard.
 */
export default function RoleGuard({ allow, children }) {
    const { user } = useAuth();
    const location = useLocation();

    // Stable state reference so react-router doesn't see a new object each render
    const navState = useMemo(() => ({ from: location }), [location]);

    if (user === null) {
        return (
            <div className="min-h-screen grid place-items-center bg-[#F7F5F0] text-[#6F6B63]" data-testid="role-checking">
                Checking permissions…
            </div>
        );
    }
    if (user === false) {
        return <Navigate to="/admin/login" state={navState} replace />;
    }
    if (!allow.includes(user.role)) {
        const home = user.role === "admin" ? "/admin" : "/staff";
        return <Navigate to={home} replace />;
    }
    return children;
}
